<template>
  <div class="master-uom-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong v-if="item.id == ''">{{ $t('create') }}</strong>
              <strong v-else>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">

              <b-col cols="6" align-self="center">
                <b-form-group v-bind:label="$t('uom_name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                            v-model="item.is_active" v-bind:checked="item.is_active" :value="1" :uncheckedValue="0"/>
                </b-form-group>

              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
<!--              <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i-->
              <b-button variant="success" v-on:click="updateItem" v-if="id != null"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem" v-if="id == null"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
  import cSwitch from '../../../../components/Switch'
  import {get, create, update} from '@/api/master_uom'

  export default {
    name: 'MasterUomForm',
    props: {
      id: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'master_uom',
        item: {
          id: null,
          name: '',
          is_active: 1
        },
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Get details of object
       */
      getDetails() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        update(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        create(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      if (this.id != null) {
        this.getDetails()
      } else {
        this.item.id = ''
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/master_uom/Form.vue